import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Table, Tooltip } from "antd";
import axios from "axios";
// import {
//   CustomerOrderInfo,
//   NotificationInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../context";
import { AuditOutlined, DeleteOutlined } from "@ant-design/icons";
import MerchantOrdersDetails from "./MerchantOrdersDetails";
// import MerchantLayout from "../../layout/MerchantLayout";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  CustomerOrderInfo,
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";

const MerchantOrders = ({ dineTypeList, allowDineSetup }) => {
  const [search, setSearch] = useState("");
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { merchantOrderSaveList, rerunCustomerOrders } =
    useContext(CustomerOrderInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      // title: dineTypeList && allowDineSetup ? "Location" : "Table Number",
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      align: "center",

      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color:
              text === "dine"
                ? "green"
                : text === "pickup"
                ? "#aeaeae"
                : text === "delivery"
                ? "#b804c2"
                : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine"
            ? "DINE"
            : text === "pickup"
            ? "PICK UP"
            : text === "delivery"
            ? "DELIVERY"
            : "TAKE OUT"}
        </p>
      ),
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {text.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 110,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 110 }}>
          <Tooltip title="Order Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getProductList();
  }, [getProductList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteCustomerOrder();
    }, 2000);
  };

  const handleDeleteCustomerOrder = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    // setLoadings(true);
    axios
      .post("user/merchant/delete-customer-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete order successfully.");
          setTimeout(() => {
            // setLoadings(false);
            rerunCustomerOrders();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            id="search"
            placeholder="Search transaction # or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      {openDrawer && (
        <MerchantOrdersDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerunCustomerOrders()}
          selectedData={selectedData}
          productList={productList}
          dineTypeList={dineTypeList}
          allowDineSetup={allowDineSetup}
        />
      )}

      <Modal
        title="Delete this transaction?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MerchantOrders;
